var exports = {
  "Gt": "AvatarFrames.module__frame___MDdhRW",
  "hN": "AvatarFrames.module__ring___MDdhRW",
  "Sl": "AvatarFrames.module__image___MDdhRW",
  "F9": "AvatarFrames.module__halo___MDdhRW",
  "lw": "AvatarFrames.module__neon___MDdhRW",
  "bx": "AvatarFrames.module__rainbow___MDdhRW",
  "jB": "AvatarFrames.module__flames___MDdhRW",
  "HP": "AvatarFrames.module__frost___MDdhRW",
  "sL": "AvatarFrames.module__sakura___MDdhRW",
  "Nz": "AvatarFrames.module__orbit___MDdhRW",
  "hc": "AvatarFrames.module__galaxy___MDdhRW",
  "wY": "AvatarFrames.module__frameSpin___MDdhRW",
  "ke": "AvatarFrames.module__frameFlicker___MDdhRW",
  "CS": "AvatarFrames.module__animated___MDdhRW",
};

module.exports = exports;
